import { _ } from "svelte-i18n";
import { get } from "svelte/store";

export type SizeGuideCategory = {
  gender: string;
  category: string;
  bigAndTall: boolean;
  represent?: boolean;
};

export function findSizeGuideCategory(
  sizeGuide: string,
  tags: string[],
): SizeGuideCategory {
  const t = get(_);

  switch (sizeGuide) {
    case "REPRESENT HOODIE":
      return {
        gender: "men",
        category: t("hoodie"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT T-SHIRT":
      return {
        gender: "men",
        category: t("t-shirt"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT RACE JACKET":
      return {
        gender: "men",
        category: t("jacket"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT ENDURO JACKET":
      return {
        gender: "men",
        category: t("parka"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT RACE TROUSER":
      return {
        gender: "men",
        category: t("trousers"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT ENDURO CARGO":
      return {
        gender: "men",
        category: t("cargos"),
        bigAndTall: false,
        represent: true,
      };
    case "REPRESENT CHECKERBOARD KNIT SWEATER":
      return {
        gender: "men",
        category: t("sweater"),
        bigAndTall: false,
        represent: true,
      };
  }

  switch (sizeGuide) {
    case "Mens Footwear 40-46":
      return { gender: "men", category: t("footwear"), bigAndTall: false };
    case "Mens Numeric 28-38":
      return {
        gender: "men",
        category: t("trousers & denim"),
        bigAndTall: false,
      };
    case "Mens Trousers 28-38":
      return {
        gender: "men",
        category: t("trousers & denim"),
        bigAndTall: false,
      };
    case "Menswear 3XL-6XL":
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: true,
      };
    case "Menswear 58-66":
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: true,
      };
    case "Menswear EU":
      return {
        gender: "men",
        category: t("other outerwear"),
        bigAndTall: false,
      };
    case "Menswear XS-5XL":
      if (tags.includes("JEANS & TROUSERS-MEN-ECOM")) {
        return {
          gender: "men",
          category: t("trousers & denim"),
          bigAndTall: false,
        };
      }
      if (tags.includes("BELTS-MEN-ECOM")) {
        return { gender: "men", category: t("belts"), bigAndTall: false };
      }
      if (tags.includes("GLOVES-MEN-ECOM")) {
        return { gender: "men", category: t("gloves"), bigAndTall: false };
      }
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: false,
      };
    case "Unisex Alpha":
      if (tags.includes("JEANS & TROUSERS-MEN-ECOM")) {
        return {
          gender: "men",
          category: t("trousers & denim"),
          bigAndTall: false,
        };
      }
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: false,
      };
    case "Women Footwear 36-41":
      return { gender: "women", category: t("footwear"), bigAndTall: false };
    case "Womens Dual Alpha":
      if (tags.includes("JEANS & TROUSERS-WOMEN-ECOM")) {
        return {
          gender: "women",
          category: t("trousers & denim"),
          bigAndTall: false,
        };
      }
      return {
        gender: "women",
        category: t("outerwear & tops"),
        bigAndTall: false,
      };
    case "Womens Numeric 25-32":
      return {
        gender: "women",
        category: t("trousers & denim"),
        bigAndTall: false,
      };
    case "Womenswear EU":
      return {
        gender: "women",
        category: t("other outerwear"),
        bigAndTall: false,
      };
    case "Womenswear XS-3XL":
      if (tags.includes("JEANS & TROUSERS-WOMEN-ECOM")) {
        return {
          gender: "women",
          category: t("trousers & denim"),
          bigAndTall: false,
        };
      }

      if (tags.includes("BELTS-WOMEN-ECOM")) {
        return { gender: "men", category: t("belts"), bigAndTall: false };
      }

      if (tags.includes("GLOVES-MEN-ECOM")) {
        return { gender: "men", category: t("gloves"), bigAndTall: false };
      }
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: false,
      };

    default:
      return {
        gender: "men",
        category: t("outerwear & tops"),
        bigAndTall: false,
      };
  }
}
